<gg-dropdown [placement]="menuPlacement" class="block w-full" [autoClose]="'outside'" #profileDd (openChange)="$event || (langCollapsed = true)">

    <button ggDropdownToggle
            class="btn btn-ghost w-full justify-start h-auto py-2"
            [ngClass]="{'btn-active': profileDd.isOpen()}">
        <!-- Kroužek kolem avataru = ZBÝVAJÍCÍ limit plánu (ubývá jako baterie); ≤ 20 % → warning. -->
        <span class="relative inline-flex items-center justify-center size-10 shrink-0">
            @if (usage.remainingPercent() !== null) {
                <svg class="absolute inset-0 -rotate-90" viewBox="0 0 40 40" aria-hidden="true">
                    <circle cx="20" cy="20" r="19" fill="none" stroke-width="2" class="stroke-base-content/10"/>
                    <circle cx="20" cy="20" r="19" fill="none" stroke-width="2" stroke-linecap="round"
                            pathLength="100" [attr.stroke-dasharray]="usage.remainingPercent() + ' 100'"
                            [class.stroke-primary]="!usage.lowRemaining()" [class.stroke-warning]="usage.lowRemaining()"/>
                </svg>
            }
            <span class="w-8 h-8 rounded-full bg-primary text-primary-content inline-flex items-center justify-center font-semibold text-sm uppercase">{{ getUserInitials() }}</span>
        </span>
        <div class="flex-1 overflow-hidden ml-1 text-left">
            <div class="flex items-center gap-2 mb-1">
                <span class="font-medium text-base-content truncate text-sm leading-tight">{{ loggedInUser?.displayName || loggedInUser?.email }}</span>
            </div>
            @if (planKey) {
                <span class="block truncate text-hint uppercase">{{ planKey }}</span>
            }
        </div>
        <app-icon icon="app:next" size="md" class="opacity-50 ml-2 shrink-0"/>
    </button>

    <ng-template ggDropdownMenu>
        <div class="gg-popup min-w-56 py-2">

            <ul class="menu menu-sm px-2 pt-0 pb-1">
                <li class="menu-title">
                    {{ 'MENU.group.my-account' | translate }}
                    @if (loggedInUser?.email) {
                        <span class="block text-hint font-normal truncate max-w-56 mb-1">{{ loggedInUser.email }}</span>
                    }
                    @if (usage.remainingPercent() !== null) {
                        <!-- Vysvětlení po kliku (vzor „Spotřeba“ ve formuláři image suite) — funguje i na dotyku.
                             Vnořený overlay: klik do něj CDK nepočítá jako „venku“ pro menu profilu, to zůstane otevřené. -->
                        <gg-dropdown #usageInfo placement="bottom-start" [autoClose]="'outside'" class="block mb-1">
                            <button type="button" ggDropdownToggle
                                    class="btn btn-ghost btn-xs h-auto min-h-0 w-full justify-start gap-2 px-1 py-1 -mx-1 font-normal"
                                    [attr.aria-expanded]="usageInfo.isOpen()" (keydown.escape)="usageInfo.close()">
                                <progress class="progress h-1 flex-1" [class.progress-primary]="!usage.lowRemaining()"
                                          [class.progress-warning]="usage.lowRemaining()"
                                          [value]="usage.remainingPercent()" max="100"
                                          [attr.aria-label]="'topbar.usage.aria' | translate"></progress>
                                <span class="text-hint whitespace-nowrap" [class.text-warning]="usage.lowRemaining()">{{ 'topbar.usage.remaining' | translate: {remaining: usage.remainingPercent()} }}</span>
                                <app-icon icon="app:info" size="sm" class="opacity-40 shrink-0"/>
                            </button>
                            <ng-template ggDropdownMenu>
                                <div class="gg-popup w-72 max-w-[calc(100vw-2rem)] p-4 flex flex-col gap-2">
                                    <div class="flex items-start justify-between gap-2">
                                        <span class="font-semibold text-sm">{{ 'topbar.usage.aria' | translate }}</span>
                                        <button type="button" class="btn btn-ghost btn-xs btn-circle -mt-1 -mr-2"
                                                [attr.aria-label]="'common.close' | translate" (click)="usageInfo.close()">
                                            <app-icon icon="app:close" size="sm"/>
                                        </button>
                                    </div>
                                    <p class="text-muted leading-relaxed">{{ 'dashboard.alert.usage.hint' | translate }}</p>
                                </div>
                            </ng-template>
                        </gg-dropdown>
                    }
                </li>
                <li>
                    <!-- FREE: vstup k upgradu → „Předplatné a ceny“ v barvě primary (jediné zvýraznění v menu);
                         placený plán: neutrální „Moje předplatné“. -->
                    @if (planKey === 'free') {
                        <a [routerLink]="'/page/subscription'" class="text-primary" (click)="profileDd.close()">
                            <app-icon icon="ph:tag" size="md" class="shrink-0"/>
                            {{ 'topbar.upgrade.button' | translate }}
                        </a>
                    } @else {
                        <a [routerLink]="'/page/subscription'" (click)="profileDd.close()">
                            <app-icon icon="ph:chart-bar" size="md" class="shrink-0"/>
                            {{ 'topbar.profile.dropdown.my-subscription' | translate }}
                        </a>
                    }
                </li>
                <li>
                    <a [routerLink]="'/page/subscription/password-change'" (click)="profileDd.close()">
                        <app-icon icon="ph:password" size="md" class="shrink-0"/>
                        {{ 'topbar.profile.dropdown.change-password' | translate }}
                    </a>
                </li>
                <li>
                    <a [routerLink]="'/page/integrations'" (click)="profileDd.close()">
                        <app-icon icon="ph:plugs-connected" size="md" class="shrink-0"/>
                        {{ 'MENU.Integrations' | translate }}
                    </a>
                </li>
            </ul>

            <div class="popup-separator"></div>

            <ul class="menu menu-sm p-2 py-1">
                <!-- Theme toggle -->
                <li>
                    <button type="button" (click)="themeService.toggle()">
                        @if (themeService.isDark()) {
                            <app-icon icon="ph:sun" size="md" class="shrink-0"/>
                            <span class="flex-1">{{ 'topbar.theme.light' | translate }}</span>
                        } @else {
                            <app-icon icon="ph:moon" size="md" class="shrink-0"/>
                            <span class="flex-1">{{ 'topbar.theme.dark' | translate }}</span>
                        }
                    </button>
                </li>
                <!-- Language -->
                <li>
                    <button type="button" (click)="langCollapsed = !langCollapsed">
                        <app-icon icon="ph:translate" size="md" class="shrink-0"/>
                        <span class="flex-1">{{ 'topbar.lang.tooltip' | translate }}</span>
                        <span class="sidebar-chevron opacity-50" [class.is-collapsed]="langCollapsed">▾</span>
                    </button>
                </li>
            </ul>

            <div class="grid transition-[grid-template-rows] duration-200"
                 [style.gridTemplateRows]="langCollapsed ? '0fr' : '1fr'">
                <div class="overflow-hidden">
                    <div class="bg-base-200 py-1 overflow-y-auto custom-scrollbar lang-dropdown-menu">
                        @for (lang of languages; track lang.code) {
                            <button type="button"
                                    class="flex items-center gap-2 py-2 px-4 w-full hover:bg-base-300 text-start transition-colors cursor-pointer"
                                    (click)="setLanguage(lang); profileDd.close()">
                                <app-icon [icon]="`flagpack:${lang.flag}`" size="sm" class="shrink-0"/>
                                <span class="text-sm"
                                      [ngClass]="currentLanguage.code === lang.code ? 'text-primary font-medium' : 'text-base-content font-normal'">
                                    {{ lang.name | translate }}
                                </span>
                                @if (currentLanguage.code === lang.code) {
                                    <app-icon icon="app:check" size="sm" class="ml-auto text-primary"/>
                                }
                            </button>
                        }
                    </div>
                </div>
            </div>

            @if (isMock && !mockToolbar.visible()) {
                <div class="popup-separator"></div>
                <ul class="menu menu-sm p-2 py-1">
                    <li>
                        <button type="button" (click)="mockToolbar.show()">
                            <app-icon icon="ph:cpu" size="md" class="shrink-0"/>
                            <span class="flex-1">Zobrazit MSW toolbar</span>
                        </button>
                    </li>
                </ul>
            }

            <div class="popup-separator"></div>

            <ul class="menu menu-sm px-2 pt-1 pb-2">
                <li>
                    <button class="text-error" type="button" (click)="logout()">
                        <app-icon icon="app:logout" size="md" class="shrink-0"/>
                        <span class="font-medium">{{ 'topbar.profile.dropdown.logout' | translate }}</span>
                    </button>
                </li>
            </ul>

            <div class="px-4 pb-1 flex items-center justify-between">
                <button type="button" class="btn btn-link btn-xs h-auto min-h-0 px-0 text-micro text-base-content/50 hover:text-base-content"
                        (click)="profileDd.close(); openLicenses()">
                    {{ 'topbar.profile.dropdown.licenses' | translate }}
                </button>
                <span class="text-micro">v{{ appVersion }}</span>
            </div>

        </div>
    </ng-template>
</gg-dropdown>
